import React from 'react'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import InvoiceEntry from '../InvoiceEntry/InvoiceEntry'
import { CCard, CCardHeader, CListGroup } from '@coreui/react'
import styles from './invoicelist.module.scss'

const InvoiceList = ({ invoiceList, openInvoiceDetails, isAccountPostBill, downloadInvoice }) => {
  const { t } = useTranslation()
  return invoiceList.length ? (
    <CCard className={styles.cardStyle}>
      <CCardHeader className={styles.containerHeaderDiv}>
        <div className={styles.headerStyle}>
          <div>{t('invoices.date')}</div>
          <div>{t('invoices.period')}</div>
          <div className={styles.total}>{t('common.total')}</div>
          <div>{t('invoices.invoice')}</div>
          <div>{t('invoices.reports')}</div>
          <div>{t('invoices.detail')}</div>
        </div>
      </CCardHeader>
      <div className={styles.invoiceEntriesContainerDiv}>
        <CListGroup flush>
          {invoiceList.map((invoice, index) => (
            <InvoiceEntry
              key={index}
              data={invoice}
              openInvoiceDetails={openInvoiceDetails}
              isAccountPostBill={isAccountPostBill}
              downloadInvoice={downloadInvoice}
            />
          ))}
        </CListGroup>
      </div>
    </CCard>
  ) : null
}

InvoiceList.defaultProps = {
  invoiceList: [],
  openInvoiceDetails: noop,
  downloadInvoice: noop,
  isAccountPostBill: false,
}

InvoiceList.propTypes = {
  invoiceList: PropTypes.array,
  downloadInvoice: PropTypes.func,
  openInvoiceDetails: PropTypes.func,
  isAccountPostBill: PropTypes.bool,
}

export default InvoiceList
